import { fetch } from '@/shared/fetch';

export const updateUserForQuestionnaire = async (
    submissionId: string,
): Promise<void> => {
    return await fetch(`/api/questionnaire/${submissionId}`, 'PATCH');
};
